export default __webpack_public_path__ + "static/media/icon_portal.3be341e6.svg";